import { createRoute } from '@tanstack/react-router';
import { NewSite } from '../components/new-site.tsx';
import { Route as parent } from './signed-in.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: '/new', component: NewSite });
